import { SnapshotTypeEnum } from '../../model/snapshot_type';

import { LatestVolSurfaceParams, LatestVolSurfaceRequest } from './interfaces/snapshot_data';

class SnapshotRequest implements LatestVolSurfaceRequest {
  params: LatestVolSurfaceParams;
  jsonrpc: string;
  method: string;
  id: string;
  format?: string;

  constructor(id: string, token: string, type: SnapshotTypeEnum, timestamp?: string) {
    this.id = id;
    this.method = id.includes(`historic_data_${token}`)
      ? 'historic_vol_surface'
      : 'subscribe.latest_vol_surface';
    this.jsonrpc = '2.0';

    this.params = {
      type: type,
      token,
      timestamp,
      model: 'SVI',
    };
    if (id.includes(`historic_data_${token}`)) {
      this.params.format = 'json';
    }
  }
}

class UnsubscribeRequest implements LatestVolSurfaceRequest {
  params: any;
  jsonrpc: string;
  method: string;
  id: string;

  constructor(id: string, channelId: number) {
    this.id = id;
    this.method = 'unsubscribe';
    this.jsonrpc = '2.0';

    this.params = {
      channel_id: channelId,
    };
  }
}

export { SnapshotRequest, UnsubscribeRequest };
